import React from "react";
import { useState, useEffect } from "react";
import SocietyImagesComponent from "./societyImages";
import { Cookies } from "react-cookie";
import "./societyImages.scss";
import { addImages } from "../../../../redux/slice/addImagesSlice";
import { connect } from "react-redux";
import Notify from "../../common/notify/notify";
import { getSocityImages } from "../../../../redux/slice/getSocityImagesSlice";
import upld_img_icn from "../../../../assets/images/upload.png";
import { API_KEY } from "../../../../environment";

const SocietyImages = (props) => {
  const { calladdImagesData, callgetSocityImagesData, getSocityImagesData } =
    props;

  const [logo, setLogo] = useState(null);
  const [preview, setPreview] = useState(null);
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [DefaultError, setDefaultError] = useState({});
  const [imageSrc, setImageSrc] = useState("");
  const [imagesSrc, setImagesSrc] = useState([]);
  const [logoAction, setLogoAction] = useState("keep");
  const [retainedImages, setRetainedImages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  let url;

  const cookies = new Cookies();
  const id = cookies.get("societyId");

  useEffect(() => {
    const fetchImageData = async () => {
      if (id) {
        setIsLoading(true);
        try {
          const res = await callgetSocityImagesData(id);
          if (res.type === "getSocityImages/fulfilled") {
            const logoPath = res?.payload?.data?.data?.logo;
            if (logoPath) {
              url = `${API_KEY}${logoPath}`;
              try {
                const response = await fetch(url);
                const blob = await response.blob();
                setImageSrc(URL.createObjectURL(blob));
              } catch (err) {
                setImageSrc("");
              }
            } else {
              setImageSrc("");
            }
          }
        } catch (err) {
          setImageSrc("");
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchImageData();
  }, [id]);

  useEffect(() => {
    const fetchImageData = async () => {
      if (!id) return;

      setIsLoading(true);
      try {
        const res = await callgetSocityImagesData(id);
        if (res.type === "getSocityImages/fulfilled") {
          const socImages = res?.payload?.data?.data?.images || [];

          if (!Array.isArray(socImages)) {
            setImagesSrc([]);
            setRetainedImages([]);
            return;
          }

          setRetainedImages(socImages);

          if (socImages.length > 0) {
            const imagePromises = socImages.map(async (img, index) => {
              const url = `${API_KEY}${img}`;
              try {
                const response = await fetch(url);
                const blob = await response.blob();
                return {
                  url: URL.createObjectURL(blob),
                  path: img,
                  index,
                };
              } catch (error) {
                return null;
              }
            });

            const imageData = (await Promise.all(imagePromises)).filter(
              Boolean
            );
            setImagesSrc(imageData);
          } else {
            setImagesSrc([]);
          }
        }
      } catch (error) {
        setImagesSrc([]);
        setRetainedImages([]);
      } finally {
        setIsLoading(false);
      }
    };
    fetchImageData();
  }, [id]);

  const societyLogo =
    getSocityImagesData && getSocityImagesData.getSocityImagesData
      ? getSocityImagesData.getSocityImagesData.data?.data?.logo
      : null;

  useEffect(() => {
    if (societyLogo) {
      setPreview(
        societyLogo.startsWith("http") ? societyLogo : `${url}${societyLogo}`
      );
    }
  }, [societyLogo]);

  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setLogo(file);
      const previewUrl = URL.createObjectURL(file);
      setPreview(previewUrl);
      setImageSrc(previewUrl);
      setLogoAction("update");
    }
  };

  const handleRemoveLogo = () => {
    setLogo(null);
    setPreview(null);
    setImageSrc("");
    setLogoAction("remove");
  };

  const handleUploadLogo = async () => {
    let error = {};
    if (logoAction === "update" && !logo) {
      error.logo = "No logo uploaded";
      setDefaultError(error);
      return;
    }

    setIsLoading(true);
    const formData = new FormData();

    if (logoAction === "update") {
      formData.append("logo", logo);
    }

    formData.append("logoAction", logoAction);

    formData.append("retainedImages", JSON.stringify(retainedImages));

    try {
      const result = await calladdImagesData({ id, formData });
      if (result.type === "addImages/fulfilled") {
        if (logoAction === "remove") {
          setLogo(null);
          setPreview(null);
          setImageSrc("");
        }

        if (logoAction === "update") {
          Notify("success", "The logo has been uploaded successfully", "");
          setLogo(null);
        } else if (logoAction === "remove") {
          Notify("success", "The logo has been removed successfully", "");
        }
        setLogoAction("keep");

        await callgetSocityImagesData(id);

        const fileInput = document.querySelector(
          ".logo-upload-container .file-input"
        );
        if (fileInput) fileInput.value = "";
      } else if (result.type === "addImages/rejected") {
        Notify(
          "error",
          "An error occurred during the logo operation. Please try again",
          ""
        );
      }
    } catch (err) {
      Notify(
        "error",
        "An unexpected error occurred while processing the logo. Please try again",
        ""
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveImage = async (index) => {
    setIsLoading(true);

    const updatedRetainedImages = [...retainedImages];
    updatedRetainedImages.splice(index, 1);

    setRetainedImages(updatedRetainedImages);
    const updatedImagesSrc = imagesSrc.filter((img) => img.index !== index);
    setImagesSrc(updatedImagesSrc);

    const formData = new FormData();
    formData.append("retainedImages", JSON.stringify(updatedRetainedImages));
    formData.append("logoAction", "keep");

    try {
      const result = await calladdImagesData({ id, formData });
      if (result.type === "addImages/fulfilled") {
        if (result?.payload?.data?.data?.images) {
          setRetainedImages(result.payload.data.data.images);

          const imagePromises = result.payload.data.data.images.map(
            async (img, idx) => {
              const url = `${API_KEY}${img}`;
              try {
                const response = await fetch(url);
                const blob = await response.blob();
                return {
                  url: URL.createObjectURL(blob),
                  path: img,
                  index: idx,
                };
              } catch (error) {
                return null;
              }
            }
          );

          const imageData = (await Promise.all(imagePromises)).filter(Boolean);
          setImagesSrc(imageData);
        }

        Notify("success", "The image has been removed successfully", "");
      } else if (result.type === "addImages/rejected") {
        setRetainedImages(retainedImages);
        setImagesSrc(imagesSrc);
        Notify("error", "Failed to remove the image. Please try again", "");
      }
    } catch (err) {
      setRetainedImages(retainedImages);
      setImagesSrc(imagesSrc);
      Notify(
        "error",
        "Something went wrong during the image removal. Kindly retry the action.",
        ""
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    const currentTotal = retainedImages.length + images.length;

    if (currentTotal + files.length > 5) {
      alert("You can only have up to 5 images total.");
      return;
    }

    const newImages = [...images, ...files];
    setImages(newImages);

    const newPreviews = [
      ...previews,
      ...files.map((file) => URL.createObjectURL(file)),
    ];
    setPreviews(newPreviews);
  };

  const handleUploadImages = async () => {
    setIsLoading(true);
    const formData = new FormData();

    formData.append("retainedImages", JSON.stringify(retainedImages));

    images.forEach((image) => {
      formData.append("newImages", image);
    });

    formData.append("logoAction", "keep");

    try {
      const result = await calladdImagesData({ id, formData });
      if (result.type === "addImages/fulfilled") {
        if (result?.payload?.data?.data?.images) {
          setRetainedImages(result.payload.data.data.images);

          const newImagesSrc = [];
          const imagePromises = result.payload.data.data.images.map(
            async (img, index) => {
              const url = `${API_KEY}${img}`;
              try {
                const response = await fetch(url);
                const blob = await response.blob();
                return {
                  url: URL.createObjectURL(blob),
                  path: img,
                  index,
                };
              } catch (error) {
                return null;
              }
            }
          );

          const imageData = (await Promise.all(imagePromises)).filter(Boolean);
          setImagesSrc(imageData);
        }

        setImages([]);
        setPreviews([]);

        const fileInput = document.querySelector(
          ".image-upload-container .file-input"
        );
        if (fileInput) fileInput.value = "";

        Notify("success", "Images have been updated successfully", "");
      } else if (result.type === "addImages/rejected") {
        Notify(
          "error",
          "An error occurred while updating the image. Please try again",
          ""
        );
      }
    } catch (err) {
      Notify(
        "error",
        "An unexpected error occurred while updating the images. Please try again",
        ""
      );
    } finally {
      setIsLoading(false);
    }
  };

  const items = [
    {
      key: "1",
      label: "Society Logo",
      children: (
        <div className="logo-main">
          <div className="logo-top">
            <p className="logo-text">
              Upload the logo of your society. This logo will be displayed on
              the application for a better user experience.
            </p>
          </div>
          <div className="logo-bottom">
            <div
              className="logo-upload-container"
              onClick={() => document.querySelector(".file-input").click()}
            >
              <div className="upload-icon">
                <img src={upld_img_icn} alt="Upload Logo" />
              </div>
              <p className="upload-text">Upload Logo</p>
              <p className="upload-subtext">Click to upload</p>
              <input
                type="file"
                accept="image/*"
                onChange={handleLogoChange}
                className="file-input"
                disabled={isLoading}
              />
            </div>
            <div
              className="preview-container"
              style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}
            >
              {imageSrc && (
                <div style={{ position: "relative" }}>
                  <img
                    src={imageSrc}
                    alt="Uploaded Logo"
                    className="uploaded-logo"
                    style={{ maxHeight: "200px", maxWidth: "200px" }}
                  />
                  <button
                    onClick={handleRemoveLogo}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      cursor: "pointer",
                    }}
                    disabled={isLoading}
                  >
                    X
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="logo-submit-btn">
            <button
              className="submit-logo-btn"
              onClick={handleUploadLogo}
              disabled={isLoading || (logoAction === "keep" && !logo)}
            >
              <span>
                {isLoading
                  ? "Processing..."
                  : logoAction === "remove"
                  ? "Remove Logo"
                  : "Upload Logo"}
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: "Society Images",
      children: (
        <div className="image-main">
          <div className="image-top">
            <p className="image-text">
              Upload the images of your society campus. These images will be
              displayed on the application for a better user experience.
            </p>
          </div>
          <div className="image-bottom">
            <div
              className="image-upload-container"
              onClick={() => document.querySelector(".file-input-1").click()}
            >
              <div className="upload-icon">
                <img src={upld_img_icn} alt="Upload Logo" />
              </div>
              <p className="upload-text">Upload image</p>
              <p className="upload-subtext">Click to upload</p>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleImageChange}
                className="file-input-1"
                disabled={
                  isLoading || retainedImages.length + images.length >= 5
                }
              />
            </div>
            <div
              className="preview-container"
              style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}
            >
              {imagesSrc.map((img, idx) => (
                <div key={idx} style={{ position: "relative" }}>
                  <img
                    src={img.url}
                    alt={`Existing ${idx}`}
                    className="uploaded-image"
                    style={{ maxHeight: "200px", maxWidth: "200px" }}
                  />
                  <button
                    onClick={() => handleRemoveImage(idx)}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      cursor: "pointer",
                    }}
                    disabled={isLoading}
                  >
                    X
                  </button>
                </div>
              ))}

              {previews.map((src, index) => (
                <div key={`new-${index}`} style={{ position: "relative" }}>
                  <img
                    src={src}
                    alt={`New ${index}`}
                    className="uploaded-image"
                    style={{ maxHeight: "200px", maxWidth: "200px" }}
                  />
                  <button
                    onClick={() => {
                      const newImages = [...images];
                      newImages.splice(index, 1);
                      setImages(newImages);

                      const newPreviews = [...previews];
                      newPreviews.splice(index, 1);
                      setPreviews(newPreviews);
                    }}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      cursor: "pointer",
                    }}
                    disabled={isLoading}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="image-submit-btn">
            <button
              className="submit-image-btn"
              onClick={handleUploadImages}
              disabled={
                isLoading ||
                (images.length === 0 &&
                  retainedImages.length === imagesSrc.length)
              }
            >
              <span>{isLoading ? "Processing..." : "Update Images"}</span>
            </button>
          </div>
        </div>
      ),
    },
  ];
  return (
    <div>
      <SocietyImagesComponent items={items} />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    addImagesData: state.addImagesData,
    getSocityImagesData: state.getSocityImagesData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    calladdImagesData: ({ id, formData }) =>
      dispatch(addImages({ id, formData })),
    callgetSocityImagesData: (id) => dispatch(getSocityImages(id)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocietyImages);
